// Message d'inscription à un tournoi FFT (SMS / email au juge-arbitre).
// Toujours en français : le destinataire est un JA français, quelle que soit la langue de l'app.

export interface InscriptionJoueur {
  prenom: string;
  nom: string;
  licence?: string | null;
}

export interface InscriptionInput {
  categorie?: string | null; // "P500"
  dateIso?: string | null; // AAAA-MM-JJ
  dateFallback?: string | null; // date_str brute si dateIso absent
  j1: InscriptionJoueur;
  j2: InscriptionJoueur;
}

function parseIso(iso: string): Date {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

function joueurLine(j: InscriptionJoueur): string {
  return `${j.prenom} ${j.nom.toUpperCase()} – ${j.licence || "licence à compléter"}`;
}

export function buildInscriptionMessage(input: InscriptionInput): { subject: string; body: string } {
  const { categorie, dateIso, dateFallback, j1, j2 } = input;
  const dateLong = dateIso
    ? parseIso(dateIso).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" })
    : dateFallback ?? "";
  const dateShort = dateIso ? dateIso.slice(8, 10) + "/" + dateIso.slice(5, 7) : dateFallback ?? "";

  const body = [
    "Salut,",
    "On souhaite s'inscrire au tournoi" + (categorie ? ` ${categorie}` : "") + (dateLong ? ` du ${dateLong}` : ""),
    joueurLine(j1),
    joueurLine(j2),
    "Merci",
  ].join("\n");
  const subject = [`Inscription ${categorie || "tournoi"}`, dateShort, `${j1.nom.toUpperCase()} / ${j2.nom.toUpperCase()}`]
    .filter(Boolean)
    .join(" – ");
  return { subject, body };
}

// iOS attend "sms:num&body=", Android/web "sms:num?body=".
export function smsHref(tel: string, body: string, platform: string): string {
  const num = tel.replace(/[^\d+]/g, "");
  return `sms:${num}${platform === "ios" ? "&" : "?"}body=${encodeURIComponent(body)}`;
}

export function mailHref(mail: string, subject: string, body: string): string {
  return `mailto:${mail.trim()}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
